import { render } from "./Labels.vue?vue&type=template&id=54bdcbb9&scoped=true"
import script from "./Labels.vue?vue&type=script&lang=js"
export * from "./Labels.vue?vue&type=script&lang=js"

import "./Labels.vue?vue&type=style&index=0&id=54bdcbb9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54bdcbb9"]])

export default __exports__